
export class Examination {
  
  date: any;              
  to: string;
  from: string;
  subject: string;         
  taxYear: number;
  industry: string;
  numberOfProjects: number;
  total: number;           
  recommendation: 'Approval' | 'Deny' | null;
  
  projectName: string;

  q1BusinessComponent: string;
  q1iNewOrImproved: 'New' | 'Improved' | null;
  q1iiProduct: boolean;
  q1iiProcess: boolean;
  q1iiComputerSoftware: boolean;
  q1iiTechnique: boolean;
  q1iiFormula: boolean;
  q1iiInvention: boolean;
  q1iiiFunction: boolean;
  q1iiiPerformance: boolean;
  q1iiiReliability: boolean;
  q1iiiQuality: boolean;

  q2TechnicalUncertainty: string;

  q3UncertainCapability: boolean;
  q3UncertainMethod: boolean;
  q3UncertainAppropriateDesign: boolean;
  q3AvailablePriorToResearch: string;

  q4ProcessOfExperimentation: string;
  q4iEvaluatedAlternatives: string;
  q4iiExplainedEvaluation: boolean;
  q4iiiDescribedFailures: boolean;
  q4ivProvidedEvidence: boolean;

  q5ExperimentalOrLab: string;
  q6CommercialProduction: string;
  q7AdaptationDuplication: string;
  q8ResearchInLouisiana: boolean;
  q9HowFunded: string;

  constructor(examination?: any) {
    this.date = null;
    this.to = null;
    this.from = null;
    this.subject = 'Detailed Examination';
    this.taxYear = null;
    this.industry = null;
    this.numberOfProjects = null;
    this.total = null;
    this.recommendation = null;

    this.projectName = null;

    this.q1BusinessComponent = null;
    this.q1iNewOrImproved = null;
    this.q1iiProduct = false;
    this.q1iiProcess = false;
    this.q1iiComputerSoftware = false;
    this.q1iiTechnique = false;
    this.q1iiFormula = false;
    this.q1iiInvention = false;
    this.q1iiiFunction = false;
    this.q1iiiPerformance = false;
    this.q1iiiReliability = false;
    this.q1iiiQuality = false;

    this.q2TechnicalUncertainty = null;

    this.q3UncertainCapability = false;
    this.q3UncertainMethod = false;
    this.q3UncertainAppropriateDesign = false;
    this.q3AvailablePriorToResearch = null;

    this.q4ProcessOfExperimentation = null;
    this.q4iEvaluatedAlternatives = null;
    this.q4iiExplainedEvaluation = null;
    this.q4iiiDescribedFailures = null;
    this.q4ivProvidedEvidence = null;

    this.q5ExperimentalOrLab = null;
    this.q6CommercialProduction = null;
    this.q7AdaptationDuplication = null;
    this.q8ResearchInLouisiana = null;
    this.q9HowFunded = null;

    if (examination) {
      Object.assign(this, examination);
    }

    this.date = this.date ? new Date(this.date) : null;
  }
}
